import dynamic from "next/dynamic";

const DynamicProposalPreviewModal = dynamic(
  () => import("modules/trade-proposals/components/ProposalPreviewModal"),
  {
    loading: () => <></>,
  }
);

export default DynamicProposalPreviewModal;
